import { i18n } from '@/lang/i18n';
import { environmentService, postRequestHandler, getRequestHandler } from '@/utils/services';
import { dttmenu } from '@/routes/magicnav';

import { compressToUTF16 as compress, decompressFromUTF16 as decompress } from 'lz-string';

import axios from 'axios';

const state = {
  apiUrl: null,
  apiUrlUser: null,
  isLoadingLogin: false,
  headers: null,
  headersWithFile: null,
  clients: [],
  allClientsFlat: [],
  userclients: [],
  allusers: [],
  listUsers: [],
  clientstype: [],
  roles: [],
  user: {},
  navbar: {},
  dttmenu: {},
  userRoute: {},
  validate: {},
  clienttypeselected: [],
  rolespeselected: [],
  namesearch: "",
  total: 0,
  status: [],
  channels: [],
  reloadGrid:0,
  refreshUserList:false,
  languages:[],
},

      getters = {
        apiUrl: state => state.apiUrl,
        isLoadingLogin: state => state.isLoadingLogin,
        apiUrlUser: state => state.apiUrlUser,
        user: state => state.user,
        rol: state => state.user.role.name,
        headers: state => state.headers,
        clients: state => state.clients,
        allClientsFlat: state => state.allClientsFlat,
        userclients: state => state.userclients,
        clientstype: state => state.clientstype,
        allusers: state => state.allusers,
        listUsers: state => state.listUsers,
        roles: state => state.roles,
        magicNav: state => state.navbar,
        userRoute: state => state.userRoute,
        loginError: state => state.loginError,
        headersWithFile: state => state.headersWithFile,
        validate: state => state.validate,
        clienttypeselected: state => state.clienttypeselected,
        rolespeselected: state => state.rolespeselected,
        namesearch: state => state.namesearch,
        total: state => state.total,
        status: state => state.status,
        channels: state => state.channels,
        reloadGrid: state => state.reloadGrid,
        refreshUserList: state => state.refreshUserList,
        languages: state => state.languages
      },

      mutations = {
        setNavbar(state) {
          const roleName = state.user && state.user.role ? state.user.role.name : null;
          const roleCode = state.user && state.user.role ? state.user.role.code : null;
          let roleConfig = state.dttmenu[roleName];
          if (!roleConfig && roleCode === 'OPE') {
            roleConfig = state.dttmenu['Manager'];
          }
          if (roleConfig && roleConfig.modules) {
            const modules = JSON.parse(JSON.stringify(roleConfig.modules));
            const isSalerOperator = (roleCode === 'SLR' || roleName === 'Saler') &&
              state.user && state.user.clients &&
              (state.user.clients.typeCode === 'OPE' || state.user.clients.type_code === 'OPE');
            if (isSalerOperator) {
              modules.roomtypes = {
                name: 'Room Types',
                uri: '/roomtypes',
                permissions: []
              };
            }
            state.navbar = modules;
          } else {
            state.navbar = {};
          }
        },

        setAuthUrls(state) {
          state.apiUrl = environmentService.apiUrlAuth;
          state.apiUrlUser = environmentService.apiUrlUser;
        },

        loadingLoginToggle(state) {
          state.isLoadingLogin = !state.isLoadingLogin;
        },

        setUserRoute(state, payload){
          state.userRoute = payload;
        },
        setHeaders(state, payload) {
          state.headers = {
            'Authorization': `Bearer ${payload}`
          };
        },

        setActiveUser(state, payload) {
          state.user = payload;
        },

        setFileHeaders(state, payload){
          state.headersWithFile = { 'Authorization': `Bearer ${payload}`,'Content-Type': 'multipart/form-data' };
        },

        setClients(state, payload) {
          state.clients = payload;
        },
        setAllClientsFlat(state, payload) {
          state.allClientsFlat = payload;
        },
        setTotalClients(state, payload) {
          state.total = payload;  
        },
        setMenu(state) {
          state.dttmenu = dttmenu;
        },

        setChannels(state, payload) {
          state.channels = payload;
        },
        setClientstype(state, payload) {
          state.clientstype = payload;
        },
        setAllclients(state, payload) {
          state.allusers = payload;
        },
        setUsersList(state, payload) {
          state.listUsers = payload;
        },
        setUserRole(state, payload) {
          state.roles = payload;
        },
        setUserClients(state, payload){
          state.userclients = payload;
        },
        setValidateUser(state, payload) {
          if (payload.action == 'update') {
            let recordId = payload.record.data.id;
            let index = state.allusers.users.findIndex(record => record.id == recordId);
            state.allusers.users[index] = payload.record.data;
          } else {
            state.allusers.users.push(payload.data);
          }
          state.reloadGrid +=1;
        },
        setTotal(state, payload) {
          state.total = payload
        },
        setClienttypeselected(state, payload) {
          state.clienttypeselected = payload;
        },
        setRolespeselected(state, payload) {
          state.rolespeselected = payload;
        },
        setNamesearch(state, payload) {
          state.namesearch = payload;
        },
        setStatus(state, payload) {
          state.status = payload
        },
        refreshUserList(state) {
          state.reloadGrid +=1;
        },
        setLanguages(state, payload) {
          state.languages = payload;
        }
      },

      actions = {
        async getLanguages({ commit, state }) {
          await axios.get(`${state.apiUrlUser}/users/languages`, { headers: state.headers })
                     .then(response => {
                       commit('setLanguages', response.data.data);
                     })
                     .catch(error => error)
        },
        async setAuthUrls({ commit }) {
          commit('setAuthUrls');
        },
        async login({ commit, state, dispatch, rootState }, payload) {
          commit('loadingLoginToggle');
          i18n.locale = rootState.global.locale;
          await axios.post(`${state.apiUrl}/login-web`, payload)
          .then(response => {
            if (response.data.status == 200) {
              commit('setHeaders', response.data.data);
              commit('setFileHeaders', response.data.data);
              dispatch('getUserClient', {token: response.data.data, login:true});
              commit('loadingLoginToggle');
              const ipMessage = response.data.ip ? `${response.data.ip}` : 'unknown';
              dispatch('global/setToastNotification', {title: "IP:", text: ipMessage, duration:3000, type:'success'}, {root: true});
            } else {
              dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.login'), text:i18n.t('lang.store.auth.error'), type:'danger'}, {root:true});
            }
          })
          .catch(error => error);
          commit('loadingLoginToggle');
        },

        async getUserClient({commit, state }, payload, update = false) {
          await axios.post(`${state.apiUrl}/validate`, { next: 'auth/validate' }, { headers: state.headers }).then(response => {
            const user = response.data.data;
            const userLogged = {
              id: user.id,
              status: user.status,
              client_id: user.client_id || null,
              name: user.name,
              email: user.email,
              role: user.role,
              access: user.role.access,
              access_token: payload.token,
              clients: user.client,
              first_name: user.first_name,
              last_name: user.last_name,
            };
            localStorage.setItem('allowedModules', compress(JSON.stringify(userLogged.role.access)));
            localStorage.setItem('user', compress(JSON.stringify(userLogged)));
            localStorage.setItem('locale', user.lang.toLowerCase());
            commit('global/updateLocale', user.lang.toLowerCase(), {root: true});
            if (payload.login){
              window.location.href = '/home';
            }
          })
            .catch(error => {console.log(error)});
        },

        async getChannels({commit, state}){
            await axios.get(`${state.apiUrlUser}/channels`, { headers: state.headers}).then(response => {
                commit('setChannels', response.data.data)
            }).catch(error => {})
        },

        async getActiveUser({ commit, state, dispatch }) {
          try {
            var user = await JSON.parse(decompress(localStorage.getItem('user')));
            commit('setHeaders', user.access_token);
            commit('setFileHeaders', user.access_token);
            commit('setActiveUser', user != null ? user : {});
            commit('setNavbar');
          } catch (error) {}
        },

        async getClients({commit, state}, payload = {} ) {
          try {
            commit ('loadingLoginToggle', true);
            const pagination = payload.pagination || { page: 1, per_page: 20 };
            const sort = payload.sort || { field: null, order: null };
            let url = `${state.apiUrlUser}/clients?next=clients&pagination[page]=${pagination.page}&pagination[per_page]=${pagination.per_page||20}&&sort[field]=${sort.field||null}&sort[order]=${sort.order||null}&is_paginated=${payload.is_paginated}`;
            if (payload.searchField) {
              url += `&searchField=${encodeURIComponent(payload.searchField)}`;
            }
            let AllClients = await getRequestHandler(
              url,
              { headers: state.headers }
            );  
            if (payload.is_paginated && AllClients.pagination && Array.isArray(AllClients.clients)) {
              commit('setTotalClients', AllClients.pagination.total || 0);
              commit('setClients', AllClients.clients || []);
              commit('loadingLoginToggle', false);
            } else if (!payload.is_paginated && Array.isArray(AllClients.clients)) {
              commit('setAllClientsFlat', AllClients.clients || []);
              commit('loadingLoginToggle', false);
            } else {
              commit('setTotalClients', 0);
              commit('setClients', []);
              commit('loadingLoginToggle', false);
            }
          } catch (error) {
            commit('setClients', []);
            commit ('loadingLoginToggle', false);
          }
        },

        async updateClientMarkup({ commit, state, dispatch, rootState }, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlUser}/clients/markup`, payload,{ headers: state.headers })
          if(result.status == 200){
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.clientMarkup'), text: payload.operator+' '+i18n.t('lang.store.auth.clientMarkupSuccess'), duration:2000, type:'success'}, {root: true});
          }else{
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.clientMarkup'), text: i18n.t('lang.store.auth.clientMarkupFailed'), type:'danger'}, {root: true});
          }
          return result;
        },

        async updateClientFee({ commit, state, dispatch, rootState }, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlUser}/clients/fee`, payload,{ headers: state.headers })
          if(result.status == 200){
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.clientFee'), text: payload.operator+' '+i18n.t('lang.store.auth.clientFeeSuccess'), duration:2000, type:'success'}, {root: true});
          }else{
            dispatch('global/setToastNotification', {title:i18n.t('lang.store.auth.clientFee'), text: i18n.t('lang.store.auth.clientFeeFailed'), type:'danger'}, {root: true});
          }
          return result;
        },
        async updateCochaClientNemo({ commit, state, dispatch, rootState }, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlUser}/clients/cocha/nemo/update`, payload,{ headers: state.headers })
          if(result.status == 200){
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.clientFee'), text: i18n.t('lang.store.auth.clientFeeSuccess'), duration:2000, type:'success'}, {root: true});
          }
          return result;
        },

        setMenu({ commit }) {
          commit('setMenu');
        },

        async getRedirect({ commit, state }) {
          try {
            let userRoute;
            if (state.user.role.name == "Hotel") {
              userRoute = {
                'text': 'Go to your Hotel Inventory',
                'router': '/inventory',
                'showRedirect': true
              };
            } else if (state.user.role.name == "Admin") {
              userRoute = {
                'text': 'Manage users',
                'router': '/users',
                'showRedirect': true
              };
            } else {
              userRoute = {
                'text': 'Search the best room',
                'router': '/availability',
                'showRedirect': true
              };
            }
            await commit('setUserRoute', userRoute);
          } catch (error) {}
        },

        logout() {
          localStorage.removeItem('user');
          localStorage.removeItem('access_token');
          localStorage.removeItem('countries');
          window.location.href = '/login';

        },

        async getUserClients({
          commit,
          state
        }) {
          let UserClients = await getRequestHandler(`${state.apiUrlUser}/clients`, {
            headers: state.headers
          });
          commit('setUserClients', UserClients.data.clients || UserClients.data || UserClients);
        },
        async getClientsType({
          commit,
          state
        }) {
          let ClientsType = await getRequestHandler(`${state.apiUrlUser}/clients/types`, {
            headers: state.headers
          });
          commit('setClientstype', ClientsType);
        },
        async getAllUserClients({
          commit,
          state
        }, payload) {
          if (payload.clientIds) {
            commit('setClienttypeselected', payload.clientIds)
          } else {
            commit('setClienttypeselected', [])
          }
          if (payload.roleIds) {
            commit('setRolespeselected', payload.roleIds)
          } else {
            commit('setRolespeselected', [])
          }
          if (payload.namesearch) {
            commit('setNamesearch', payload.namesearch)
          } else {
            commit('setNamesearch', [])
          }
          commit('setStatus', payload.status)
          commit('loadingLoginToggle');
          let AllUserClients = await postRequestHandler(`${state.apiUrlUser}/clients/users`, payload, {
            headers: state.headers
          });
          if (AllUserClients.status == 200) {
            commit('setTotal', AllUserClients.data.pagination.total)
            commit('setAllclients', AllUserClients.data);
            commit('setUsersList', AllUserClients.data.users);
          } else {
            commit('setTotal', 0)
            commit('setAllclients', []);
            commit('setUsersList', {data:{users:[]}});
          }

          commit('loadingLoginToggle');
        },
        async getUserRole({
          commit,
          state
        }) {
          let UserRole = await getRequestHandler(`${state.apiUrlUser}/roles`, {
            headers: state.headers
          });
          commit('setUserRole', UserRole);
        },
        async getMarkupByHotel({
          commit,
          state
        }, payload) {
          let MarkupByHotel = await postRequestHandler(`${state.apiUrlUser}/hotels/markup`, payload, {
            headers: state.headers
          });
          if (MarkupByHotel.status == 200) {
            return MarkupByHotel.data;
          } else {
            return [];
          }
        },
        async getHotelPenalties({
          commit,
          state
        }, payload) {
          let hotelPenalties = await postRequestHandler(`${state.apiUrlUser}/hotels/penalties`, payload, {
            headers: state.headers
          });
          if (hotelPenalties.status == 200) {
            return hotelPenalties.data;
          } else {
            return [];
          }
        },
        async CreateUser({
          commit,
          dispatch,
          rootState
        }, payload) {
          i18n.locale = rootState.global.locale;
          await postRequestHandler(`${state.apiUrlUser}/users/create`, payload, { headers: state.headers }).then( async result => {
            if (result.status == 201) {
              dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.userService'), text: i18n.t('lang.store.auth.userServiceSuccess'), type:'success' }, {root: true});
              dispatch('getUserClients');
              const user = await JSON.parse(decompress(localStorage.getItem('user')));
              dispatch('getUserClient', {token: user.access_token, login:false});
              commit('loadingLoginToggle');
              commit("setValidateUser", result);
              commit('loadingLoginToggle');
            } else {
              const errorText = result.errors[0].split(' ').splice(0, 5).join(' ');
              dispatch('global/setToastNotification', {title:i18n.t('lang.store.auth.userService'), text: i18n.t(`lang.store.auth.${errorText}`), type: 'danger' }, {root: true});
            }
          });
        },

        async requestUserDelete({ state, commit, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlUser}/users/delete`, payload, { headers: state.headers });
          if (result.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.userService'), text: i18n.t(`lang.store.auth.${result.data[0]}`), type: 'success' }, {root: true});
            let userspayload = {
              status: [true, false],
              pagination: {
                page: 1,
                per_page: 20,
              },
              sort: {
                field: "id",
                order: "asc",
              },
            };
            dispatch('getAllUserClients', userspayload);

            commit('loadingLoginToggle');
            commit("setValidateUser", result);
            commit('loadingLoginToggle');
            commit('refreshUserList');
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.auth.userService'), text: record.errors[0], type: 'danger' }, {root: true});
          }
          commit('refreshUserList');
        },

        async PasswordResetUser({
          commit,
          state
        }, payload) {
          commit('loadingLoginToggle');
          commit('loadingLoginToggle');
        },
        async UpdateUser({
          commit,
        }, payload) {
          commit('loadingLoginToggle');
          commit("setValidateUser", {
            record: payload,
            action: 'update'
          });
          commit('loadingLoginToggle');
        },
        getCrud({ commit, dispatch }, payload){
          const module = payload.currentModule.toLowerCase();
          if(state.user.access[payload.currentModule]){
            return state.user.access[payload.currentModule].some(function(el) {
              return el.permission === module+'.'+ payload.permission;
            });
          }else{
            return false;
          }
        }
      };

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js